/*window.onbeforeunload = function(){
  return 'Não perca esta oportunidade! Deixe o seu contacto que nós ligamos.';
};*/

//DROP DOWN THEME
function setupSelect($els){
	var wrap = '<div class="select-wrap" />',
		extras = '<div class="select-content placeholder" /><div class="select-btn" />';

	$els.each(function(){
		var $el = $(this),
			$wrap = $el.wrap(wrap).parent().append(extras);

		$el.change(function(){
			var $el = $(this),
				$optSel = $el.find(':selected'),
				$wrap = $el.parents('.select-wrap'),
				$content = $('.select-content', $wrap);
			$content.text($optSel.text());

			//simulation of placeholder font color
			if($(this).attr("placeholder") == $optSel.text()){
				$content.addClass("placeholder");
			}else{
				$content.removeClass("placeholder");
			}

		}).change();
	});
	return $els;
}
var $selects = $('select.themed');
$(function() {
	setupSelect($selects);
});
//-- ! DROP DOWN THEME


var $browser = null;
$(function() {
	
	if($browser){
		window.onbeforeunload = null;
		$("body").addClass("mobile");
	}
	
	//FX FORM
	setTimeout(function(that){
		$("form").addClass("fadein");
	}(this),1500);

	//BINDING MODAL
	$("body").on("click",".modal",function(){
		$.prompt(
			$(this).data("text")
		);	
	})
	$(".checkbox_wrap").on("click","a",function(e){
		e.preventDefault();

		if($(this).parent().data("text") != ""){
			$.prompt(
				$(this).parent().data("text")
			);		
		}
	})
	
	//LOAD LAZY IMAGES
	$(".lazy").each(function(i,ob){
		var time = 2500;
		if(!!$(ob).is(":visible")){
			time = 100;
		}
		setTimeout(function() {
		    $(ob).attr("src",$(ob).data("src"));
		}, time);
	});

	//FORM BINDING
	$("form").bind("submit",function(e){
		e.preventDefault();
		if(!validate($(this))){
			return;
		}
		if($("form").data("inprogress")){
			return;
		}

		//lead info
		var infoToSend = $("[data-send='true']").serialize();

		$("form").data("inprogress", true);

		$("form .form").hide();
		$("form .loading").addClass("fadein").show();

		$.ajax({
			url: $(this).attr("action"),
			type: "POST",
			data: infoToSend,
			dataType: "json",
			success: function(data){
				//clear
				$("form").data("inprogress", false);
				$("form .loading").hide();
				
				if(data.success){
					$("form .message").removeClass("hidden");
					
					if(!!data.trackurl){
						$("form a.facebook").attr("href",data.trackurl);	
					}
					if(!!window.jsend){window.jsend();}
					
					window.onbeforeunload = null;

					//click on facebook button in 5 seconds
					setTimeout(function(){
						$("form a.facebook")[0].click();
					},5000);

				}else{
					$("form .form").show();
					$.prompt("Erro: Por favor tente mais tarde");

				}
				
     		 }
   		});


	});
});




function validate($form){
	var req_inputs = $('input:not(:hidden,:disabled), textarea:not(:hidden,:disabled), select:not(:hidden,:disabled)', $form),
		length = req_inputs.length,
		errorElements = [],
		message = "",
		i, $el, label, label_for, $label, val, has_error;

	var $br = "<br />";
	if($browser){
		$br = "\n";
	}
	message = $br + "Foram encontrados alguns erros no seu pedido:" + $br;

	for(i = 0; i < length; i++){
		has_error = false;
		$el = $(req_inputs[i]);
		val = $el.val();

		//if checkbox
		if($el.is(":checkbox")){
			if($el.is(":checked")){
				val = true;	
			}else{
				val = '';
			}
		}

		//label = $("label[for="+$el.attr("id")+"]").html();
		label = $el.attr("placeholder");

		if((val === '' || val === $el.attr("placeholder")) && $el.hasClass('required')){
			has_error = $br+" * O campo '" + label + "' é de preenchimento obrigatório.";
		}else if($el.hasClass('email') && !isValidEmailAddress(val)){
			has_error = $br+' * O campo \'' + label + '\' não aparenta ser um endereço de email válido.';
		}else if($el.hasClass('nif') && !isValidNIF(val)){
			has_error = $br+" * O campo '" + label + "' não aparenta ser um Nº Contribuinte válido.";
		}else if($el.hasClass('telefone') && !isValidPhone(val)){
			has_error = $br+" * O campo '" + label + "' não aparenta ser um número de telefone válido.";
		}else if($el.hasClass('numbers_only') && !isNumber(val)){
			has_error = $br+" * O campo '" + label + "' não aparenta ser um número válido.";
		}else if($el.attr('minlength') > 0 && val.length < $el.attr('minlength')){
			has_error = $br+" * O campo '" + label + "' não aparenta ser um número válido.";
		}

		if(has_error){
			errorElements.push($el);
			message+=has_error;
		}
	}

	if (errorElements.length) {
		//$("form .error").html(message);
		if(!$browser){
			$.prompt(message)
		}else{
			alert(message);
		}

		errorElements[0].focus();
		$(errorElements).each(function(){
			if($(this).is("select")){
				this.parent().addClass('error');
				this.one('change', function(){
					$(this).parent().removeClass('error');
				});
			}
			if($(this).is("input")){
				this.addClass('error').one('keydown', function(){
					$(this).removeClass('error');
				});
			}
		});
		return false;
	}else{
		$("form .error").html("");
		return true;
	}
}

/*
	AUX FUNCTIONS
*/

function isValidEmailAddress(val){
	var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
	return val === '' || val.match(re);
}
function isNumber(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}
function isValidPhone(val){
	//var re = /^([9][1236][0-9]{7}$)|([0]{2}[1-9][0-9]{11}[0-9]*$)|([+]{1}[0-9]{12}[0-9]*$)|([2][1][0-9]{7}$)|([2][2][0-9]{7}$)|([2][3][1-689][0-9]{6}$)|([2][4][1-59][0-9]{6}$)|([2][5][1-689][0-9]{6}$)|([2][6][1-689][0-9]{6}$)|([2][7][1-9][0-9]{6}$)|([2][8][1-69][0-9]{6}$)|([2][9][12][0-9]{6}$)/;
	var re = /^[0-9]{9}$/;
	return (val === '' || val.match(re));
}
function isValidNIF(a){var b;var c=0;var d=function(a){return/^\d+$/.test(a)};if(a!==null&&d(a)&&a.length==9){b=a.charAt(0);if(b=="1"||b=="2"||b=="5"||b=="6"||b=="8"||b=="9"){c=b*9;var e=0;for(e=2;e<=8;e++){c+=a.charAt(e-1)*(10-e)}c=11-c%11;if(c>=10)c=0;if(c==a.charAt(8))return true}}return false}
